// extracted by mini-css-extract-plugin
export var header = "_4g-0";